import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { ILauncher } from "../../../../models/application/i-launcher";
import { launcherRestClientInjectionToken } from "../../../../rest-clients/application/launcher/launcher-rest-client-injection-token";
import { ILauncherRestClient } from "../../../../rest-clients/application/launcher/i-launcher-rest.client";

@Injectable()
export class LauncherResolver implements Resolve<ILauncher> {
  constructor(@Inject( launcherRestClientInjectionToken ) private readonly _launcherRestClient: ILauncherRestClient) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<ILauncher> {
    const launcherId: string | null = route.paramMap.get( 'launcherId' );

    if ( launcherId === null ) {
      return Promise.reject();
    }

    return this._launcherRestClient.getApplication( {
      recordId: launcherId
    } )
  }
}
